<template>
  <div class="axj-main-footer">
    <el-pagination
      :current-page="pageData.page"
      :page-size="pageData.limit"
      :total="pageData.pageTotal"
      :page-sizes="[5, 10, 15, 20]"
      @current-change="handlerCurrentChange"
      @size-change="handlerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: -10px;"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "show-club-footer",
  props:{
    pageData:{
      default:()=>{
        return{
          page: 1,
          limit: 5,
          pageTotal: 0
        }
      }
    }
  },
  methods:{
    handlerCurrentChange(row){
      this.pageData.page=row
      this.$emit("page-change",this.pageData)
    },
    handlerSizeChange(row){
      this.pageData.pageSize=row
      this.$emit("page-change",this.pageData)
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-main-footer{
  height: 50px;
  display: flex;
  align-items: center;
  .el-pager li{
    background: none;
  }
  .el-input__inner{
    background: none;
  }
  .btn-prev{
    background: none;
  }
  .btn-next{
    background: none;
  }
  .el-pagination button:disabled{
    background: none;
    color: #000000;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/axj-extracurricular/axj-show-club/component/show-club-footer/index.vue